import { createStyles, Stack, Text } from '@mantine/core';
import React from 'react';

import { useOpenRouteModal } from '@portals/framework/route-modals';
import { useIsSidebarOpen } from '@portals/redux';

import { ReactComponent as Connect } from '../../../assets/img/icons/connect.svg';

export const ConnectToggle = () => {
  const isSidebarOpen = useIsSidebarOpen();
  const { cx, classes } = useStyles();
  const openRouteModal = useOpenRouteModal();

  return (
    <Stack
      className={cx(classes.item, { open: isSidebarOpen })}
      onClick={() => openRouteModal({ modalId: 'connect' })}
      spacing="xs"
      align="center"
    >
      <Connect />

      <Text fz={10}>Connect</Text>
    </Stack>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    padding: `${theme.spacing.xs} ${theme.spacing.md} ${theme.spacing.md}`,
  },
  divider: {
    borderColor: theme.colors.blue_gray[0],
    margin: `${theme.spacing.lg} 0`,
  },
  item: {
    padding: `10px 0`,
    borderRadius: theme.spacing.sm,
    transition: 'all 0.15s ease-in-out',
    cursor: 'pointer',
    color: theme.colors.blue_gray[6],

    svg: {
      flexShrink: 0,
    },

    '&:not(.open)': {
      display: 'flex',
      justifyContent: 'center',
    },

    ':hover': {
      color: theme.colors.blue_gray[6],
      backgroundColor: theme.colors.gray[1],
    },
  },
}));
